import { useContext } from 'react';
import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';
import { WasteChecksheetDetailContext, WasteChecksheetDetailValues } from '../contexts/WasteChecksheetDetailContext';
import SubmitWasteChecksheetModal from './modals/SubmitWasteChecksheetModal';
import LeavePageModal from '../../../components/shared/dialogs/LeavePageModal';

const WasteCheckSheetDetailModals = () => {
  const { t,
    setShowSubmitAlert,
    showSubmitAlert,
    showErrorSavedAlert,
    showSavedAlert,
    setShowErrorSavedAlert,
    setShowSavedAlert,
    setShowErrorSubmitAlert,
    showErrorSubmitAlert,
    openSubmitModal,
    handleSubmitCancelModal,
    handleConfirmSubmitModal,
    itemsPreviewOnSubmitModal,
    isSubmitting,
    modifiedItems,
    blocker,
    handleLeavePageModalCancel,
    handleLeavePageModalClose,
    handleLeavePageModalConfirm,
  } = useContext(WasteChecksheetDetailContext) as WasteChecksheetDetailValues;

  return <>
    <MessagesSnackbar
      onClose={() => { setShowSubmitAlert(false); }}
      open={showSubmitAlert}
      severity='success'
      message={t('changesSubmitted')}
      duration={15000} />

    <MessagesSnackbar
      onClose={() => { setShowSavedAlert(false); }}
      open={showSavedAlert}
      severity='success'
      message={t('changesSaved')}
      duration={15000} />

    <MessagesSnackbar
      onClose={() => { setShowErrorSavedAlert(false); }}
      open={showErrorSavedAlert}
      severity='error'
      message={t('save.error')}
      duration={15000} />

    <MessagesSnackbar
      onClose={() => { setShowErrorSubmitAlert(false); }}
      open={showErrorSubmitAlert}
      severity='error'
      message={t('submit.error')}
      duration={15000} />

    <SubmitWasteChecksheetModal open={openSubmitModal}
      onClose={handleSubmitCancelModal}
      onConfirm={handleConfirmSubmitModal}
      data={itemsPreviewOnSubmitModal}
      isSubmitting={isSubmitting}></SubmitWasteChecksheetModal>

    <LeavePageModal
      open={blocker.state === 'blocked' && modifiedItems.size > 0 && !isSubmitting}
      onConfirm={handleLeavePageModalConfirm}
      onClose={handleLeavePageModalClose}
      onCancel={handleLeavePageModalCancel}
      onConfirmUrl='/store/daily-waste-checksheet'
      leaveWarningContent={t('saveOnLeaveWarningContent')}
      leaveWarningTitle={t('saveOnLeaveWarningTitle')} />
  </>;
};

export default WasteCheckSheetDetailModals;